const state = {
  config: {
    workingDir: '',
    exportID: ''
  },
  input: {
    artwork: {
      path: '',
      hasChanged: false,
      originalPath: '' // Original CDN path for edit mode comparison
    },
    animation: {
      path: '',
      duration: '',
      width: '',
      height: '',
      hasAudio: '',
      isSequence: '',
      isGif: '',
      gifFramerate: '',
      hasAlpha: '',
      thumbnail: '',
      hasChanged: false
    },
    audio: {
      path: '',
      duration: '',
      hasChanged: false
    },
    // GLB 3D-model asset (panels only): uploaded raw, no transcode.
    model: {
      path: '',
      name: '',
      hasChanged: false
    },
    packs: {
      iosPath: '',
      androidPath: '',
      hasChanged: false
    }
  },
  output: {
    artwork512: '',
    artwork1024: '',
    animation: '',
    qrCode: '',
    metadata: '',
    iosPack: '',
    androidPack: '',
    title: 'Untitled'
  }
};

const getters = {
  config() {
    return state.config;
  },
  inputArtwork() {
    return state.input.artwork;
  },
  inputAnimation() {
    return state.input.animation;
  },
  inputModel() {
    return state.input.model;
  },
  inputPacks() {
    return state.input.packs;
  },
  inputAnimationThumbnailPath() {
    return state.input.animation.thumbnail;
  },
  inputAudio() {
    return state.input.audio;
  },
  output() {
    return state.output;
  },
  outputArtwork512Path() {
    return state.output.artwork512;
  },
  outputArtwork1024Path() {
    return state.output.artwork1024;
  },
  outputAnimationPath() {
    return state.output.animation;
  },
  outputQRCodePath() {
    return state.output.qrCode;
  },
  outputMetadataPath() {
    return state.output.metadata;
  },
  outputTitle() {
    return state.output.title;
  }
};

const mutations = {
  CLEAR_STATE(state) {
    state.config = {
      workingDir: state.config.workingDir,
      exportID: ''
    };
    state.input = {
      artwork: {
        path: '',
        hasChanged: false,
        originalPath: ''
      },
      animation: {
        path: '',
        duration: '',
        width: '',
        height: '',
        hasAudio: '',
        isSequence: '',
        isGif: '',
        gifFramerate: '',
        hasAlpha: '',
        thumbnail: '',
        hasChanged: false
      },
      audio: {
        path: '',
        duration: '',
        hasChanged: false
      },
      model: {
        path: '',
        name: '',
        hasChanged: false
      },
      packs: {
        iosPath: '',
        androidPath: '',
        hasChanged: false
      }
    };
    state.output = {
      artwork512: '',
      artwork1024: '',
      animation: '',
      qrCode: '',
      metadata: '',
      iosPack: '',
      androidPack: '',
      title: 'Untitled'
    };
  },
  SET_CONFIG(state, payload) {
    state.config.workingDir = payload.workingDir;
    state.config.exportID = payload.exportID;
  },
  SET_EXPORT_ID(state, payload) {
    state.config.exportID = payload.exportID;
  },
  SET_WORKING_DIR(state, payload) {
    state.config.workingDir = payload.workingDir;
  },
  SET_INPUT_PACKS(state, payload) {
    if (payload.iosPack) {
      state.input.packs.iosPath = payload.iosPack;
    }
    if (payload.androidPack) {
      state.input.packs.androidPath = payload.androidPack;
    }
  },
  CLEAR_INPUT_PACK_IOS(state) {
    state.input.packs.iosPath = '';
  },
  CLEAR_INPUT_PACK_ANDROID(state) {
    state.input.packs.androidPath = '';
  },
  SET_INPUT_ANIMATION(state, payload) {
    state.input.animation.path = payload.animationInputPath;
    state.input.animation.duration = payload.duration;
    state.input.animation.width = payload.width;
    state.input.animation.height = payload.height;
    state.input.animation.hasAudio = payload.hasAudio;
    state.input.animation.isSequence = payload.isSequence;
    state.input.animation.hasAlpha = payload.hasAlpha;
    state.input.animation.thumbnail = payload.animationThumbnailPath;
  },
  SET_INPUT_ARTWORK_PATH(state, payload) {
    state.input.artwork.path = payload.artworkInputPath;
  },
  SET_INPUT_ANIMATION_PATH(state, payload) {
    state.input.animation.path = payload.animationInputPath;
  },
  SET_INPUT_MODEL(state, payload) {
    state.input.model.path = payload.modelInputPath;
    state.input.model.name = payload.modelName || '';
    state.input.model.hasChanged = true;
  },
  CLEAR_INPUT_MODEL(state) {
    state.input.model.path = '';
    state.input.model.name = '';
    state.input.model.hasChanged = false;
  },
  SET_INPUT_ANIMATION_DURATION(state, payload) {
    state.input.animation.duration = payload.animationInputDuration;
  },
  SET_INPUT_ANIMATION_DIMENSIONS(state, payload) {
    state.input.animation.width = payload.animationInputWidth;
    state.input.animation.height = payload.animationInputHeight;
  },
  SET_INPUT_ANIMATION_AUDIO(state, payload) {
    state.input.animation.hasAudio = payload.animationHasAudio;
  },
  SET_INPUT_ANIMATION_SEQUENCE(state, payload) {
    state.input.animation.isSequence = payload.animationIsSequence;
  },
  SET_INPUT_ANIMATION_GIF(state, payload) {
    state.input.animation.isGif = payload.animationIsGif;
  },
  SET_INPUT_ANIMATION_GIF_FRAMERATE(state, payload) {
    state.input.animation.gifFramerate = payload.gifFramerate;
  },
  SET_INPUT_ANIMATION_ALPHA(state, payload) {
    state.input.animation.hasAlpha = payload.animationHasAlpha;
  },
  SET_INPUT_ANIMATION_THUMBNAIL(state, payload) {
    state.input.animation.thumbnail = payload.animationThumbnailPath;
  },
  SET_INPUT_AUDIO_PATH(state, payload) {
    state.input.audio.path = payload.audioInputPath;
  },
  SET_INPUT_AUDIO_DURATION(state, payload) {
    state.input.audio.duration = payload.audioInputDuration;
  },
  SET_OUTPUT_ARTWORK(state, payload) {
    state.output.artwork512 = payload.artworkOutputPath512;
    state.output.artwork1024 = payload.artworkOutputPath1024;
  },
  SET_OUTPUT_ANIMATION(state, payload) {
    state.output.animation = payload.animationOutputPath;
  },
  SET_OUTPUT_PACKS(state, payload) {
    state.output.iosPack = payload.iosPath;
    state.output.androidPack = payload.androidPath;
  },
  SET_OUTPUT_QRCODE(state, payload) {
    state.output.qrCode = payload.qrCodePath;
  },
  SET_OUTPUT_METADATA(state, payload) {
    state.output.metadata = payload.metadataPath;
  },
  SET_OUTPUT_TITLE(state, payload) {
    state.output.title = payload.title;
  },
  SET_ARTWORK_HAS_CHANGED(state) {
    state.input.artwork.hasChanged = true;
  },
  CLEAR_ARTWORK_HAS_CHANGED(state) {
    state.input.artwork.hasChanged = false;
  },
  SET_ORIGINAL_ARTWORK_PATH(state, payload) {
    state.input.artwork.originalPath = payload.originalArtworkPath;
  },
  SET_ANIMATION_HAS_CHANGED(state) {
    state.input.animation.hasChanged = true;
  },
  SET_AUDIO_HAS_CHANGED(state) {
    state.input.audio.hasChanged = true;
  }
};

const actions = {
  clearState({ commit }) {
    commit('CLEAR_STATE');
  },
  setConfig({ commit }, payload) {
    commit('SET_CONFIG', payload);
  },
  setWorkingDir({ commit }, payload) {
    commit('SET_WORKING_DIR', payload);
  },
  setExportID({ commit }, payload) {
    commit('SET_EXPORT_ID', payload);
  },
  setInputArtworkPath({ commit }, payload) {
    commit('SET_INPUT_ARTWORK_PATH', payload);
  },
  setInputAnimation({ commit }, payload) {
    commit('SET_INPUT_ANIMATION', payload);
  },
  setInputAnimationPath({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_PATH', payload);
  },
  setInputModel({ commit }, payload) {
    commit('SET_INPUT_MODEL', payload);
  },
  clearInputModel({ commit }) {
    commit('CLEAR_INPUT_MODEL');
  },
  setInputAnimationDuration({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_DURATION', payload);
  },
  setInputAnimationDimensions({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_DIMENSIONS', payload);
  },
  setInputAnimationAudio({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_AUDIO', payload);
  },
  setInputAnimationSequence({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_SEQUENCE', payload);
  },
  setInputAnimationGif({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_GIF', payload);
  },
  setInputAnimationGifFramerate({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_GIF_FRAMERATE', payload);
  },
  setInputAnimationAlpha({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_ALPHA', payload);
  },
  setInputAnimationThumbnail({ commit }, payload) {
    commit('SET_INPUT_ANIMATION_THUMBNAIL', payload);
  },
  setInputAudioPath({ commit }, payload) {
    commit('SET_INPUT_AUDIO_PATH', payload);
  },
  setInputAudioDuration({ commit }, payload) {
    commit('SET_INPUT_AUDIO_DURATION', payload);
  },
  setOutputArtwork({ commit }, payload) {
    commit('SET_OUTPUT_ARTWORK', payload);
  },
  setOutputAnimation({ commit }, payload) {
    commit('SET_OUTPUT_ANIMATION', payload);
  },
  setOutputQRCode({ commit }, payload) {
    commit('SET_OUTPUT_QRCODE', payload);
  },
  setOutputMetadata({ commit }, payload) {
    commit('SET_OUTPUT_METADATA', payload);
  },
  setOutputTitle({ commit }, payload) {
    commit('SET_OUTPUT_TITLE', payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
